import { Badge } from "@/components/ui/badge";
import { BadgeCheck } from "lucide-react";
import { Track } from "@/types";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/useResponsive";
import { getTrackCoverUrl, handleImageError } from "@/utils/trackCoverUtils";
import { useNavigate } from "react-router-dom";

interface TrackCoverImageProps {
  track: Track;
}

export function TrackCoverImage({ track }: TrackCoverImageProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/tracks/${track.slug || track.id}`);
  };

  return (
    <div className="relative flex-shrink-0">
      <div
        className={cn(
          "rounded-lg overflow-hidden cursor-pointer transition-transform hover:scale-105",
          isMobile ? "w-24 h-24" : "w-32 h-32 md:w-48 md:h-48",
        )}
        onClick={handleClick}
      >
        <img
          src={getTrackCoverUrl(track.coverUrl)}
          alt={track.title}
          className="w-full h-full object-cover"
          onError={handleImageError}
        />
      </div>
      {track.isSponsored && (
        <div
          className={cn(
            "absolute",
            isMobile ? "-top-1 -right-1" : "-top-2 -right-2",
          )}
        >
          {/* Badge content */}
        </div>
      )}
    </div>
  );
}
